import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useDiscard = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (engId: string) => api.inbox.discard(engId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["inbox"] }),
  });
};
